import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import { PendingPoCard } from "./PendingPoCard";
import GCPendingPoCard from "./GCPendingPoCard";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { Typography } from "@mui/material";
import moment from "moment";
import{  Button,TextField ,InputAdornment} from "@mui/material/";
import { LocalizationProvider } from '@mui/x-date-pickers/';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import IconButton from '@mui/material/IconButton';
import dayjs from 'dayjs';

import { confirmAlert } from "react-confirm-alert";
import { CmpDatePickerField001V1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import { fAlertToast } from "../../../Utility/Utilitys";
import { UpdateRefFields_OUTLET, UpdateRefFields_VENDOR } from "../../../Server/ApiV2";
import { WmsInboundOutletRo } from "../../../Redux/roStore";

 

const GcReferenceUpdate = ({
  xOpen = false,
  fCloseDetailModal,
  xTitle = "Reference Update",
  Data=[],
  vRdxWmsHead={},
  fNewDetail=()=>{}
}) => {

  const isMobile = useMediaQuery("(max-width:425px)");

  const [modalObj,setModalObj]=useState({
    RefNo:"",
    date:new Date()
  })

// onload apicall
const fUpdate=async()=>{

  if(!modalObj?.RefNo){
    fAlertToast("FAILED", "RefNo should not be empty");
        return;
  }else if(!modalObj?.date){
    fAlertToast("FAILED","Ref Date should not be empty");
  }else{
    confirmAlert({
      title: "Update",
      message: "Are you sure you want to Update..",
      buttons: [
        {
          className: "alertBtn",
          name: "SaveYes",
          label: "Yes",
          onClick: async () => {
            const { HeadObject } = WmsInboundOutletRo();
            let Obj = { 
              p_A_VocTyp:HeadObject.A_VocTyp,
               p_A_VocNo:HeadObject.A_VocNo,
                p_NewRefNo:modalObj.RefNo,
                 p_NewRefDt:moment(modalObj.date).format("MM/DD/YYYY")
                };
            
                const Resp = await UpdateRefFields_OUTLET(Obj);
            
                if (Resp?.status === 200) {
                  fAlertToast("SUCCESS", "Successfully Updated");
                  fNewDetail(
                    vRdxWmsHead.A_VocNo,
                    vRdxWmsHead.A_Rounding,
                    vRdxWmsHead.A_VocTyp,
                    vRdxWmsHead.TaxType
                  );
                }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {
            return;
          },
        },
      ],
    });
  }

}

  return (<>
<Modal
      open={xOpen}
      onClose={()=>{
        fCloseDetailModal() 
        setModalObj({       
          RefNo:"",
          date:new Date()
        })
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        // className="
        // // gnr-item-search 
        // // model-gc-search"
      >

        <div className="p-2">
        <div style={{
          height: '45vh',
          width: isMobile ? '95%' : '50%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'var(--commonText)',
          border: '1px solid var(--primary)',
          boxShadow: '24px 24px 48px rgba(0,0,0,0.1)',
          borderRadius: '10px'
        }}>

            
              <GCTitleSticky 
                className='model-header'
                title={xTitle} onClose={()=>{
                  fCloseDetailModal()
                  setModalObj({
                    RefNo:"",
                    date:new Date()
                  })
                }}
              />  
            

        <Box sx={{width:'96%',height:'100%',margin:'auto',padding:2}}>

          <Grid container pt={1} rowSpacing={2} columnSpacing={3} className='header1'>
                        <Grid item xs={12} sm={5}>
                            <Grid container>
                            {/* <Typography>Doc Type</Typography> */}
                            <CmpTextFieldV1
                              xLabelText="Doc Type"
                              xValue={vRdxWmsHead?.A_VocTyp}
                              xType={"text"} // text/number/password
                              xName={"A_VocTyp"}
                              xReadOnly={true}
                              // xOnChange={""}
                              // xError={false}
                              // xErrorMessage={""}
                              // xOnKeyUp={xKey}
                            />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={7}>
                            <Grid container>
                            <CmpTextFieldV1
                             xLabelText="Doc Name"
                             xValue={vRdxWmsHead?.A_VocTypName}
                             xType={"text"} // text/number/password
                             xName={"A_VocTypName"}
                             xReadOnly={true}
                              // xOnChange={""}
                              // xError={false}
                              // xErrorMessage={""}
                              // xOnKeyUp={xKey}
                            />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container mt={1} rowSpacing={2} columnSpacing={3} className='header2'>
                        <Grid item xs={12}>
                            {/* <Typography>Doc No</Typography> */}
                            <CmpTextFieldV1
                              xLabelText="Doc No"
                              xValue={vRdxWmsHead?.A_VocNo}
                              xType={"text"} // text/number/password
                              xName={"A_VocNo"}
                              xReadOnly={true}
                              // xOnChange={""}
                              // xError={false}
                              // xErrorMessage={""}
                              // xOnKeyUp={xKey}
                            />
                        </Grid>
                    </Grid>

                    <Grid container  mt={1} rowSpacing={2} columnSpacing={3} className='header3'>
                        <Grid item xs={12} sm={6}>
                            <Grid container>
                                {/* <Typography>Ref No</Typography> */}
                                <CmpTextFieldV1
                                  xLabelText="Ref No"
                                  xValue={modalObj?.RefNo}
                                  xType={"text"} // text/number/password
                                  xName={"RefNo"}
                                  xOnChange={(e)=>{
                                    setModalObj((obj) => ({
                                      ...obj,
                                      [e.target.name]: e.target.value,
                                    }));
                                  }}
                                  // xError={false}
                                  // xErrorMessage={""}
                                  // xOnKeyUp={xKey}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {/* <Typography>Ref Date</Typography> */}
                                    <CmpDatePickerField001V1
                                      xLabelText="Ref Date"
                                      xName={"date"}
                                        xtabIndex={"2"}
                                        xValue={modalObj?.date}
                                        // xValue={vRdxWmsHead.A_PostDt}
                                        xOnChange={(event)=>{
                                              if (
                                                event?.$d == "Invalid Date" ||
                                                event?.$d == null ||
                                                event?.$d === undefined ||
                                                event?.$d === ""
                                              ) {
                                                setModalObj((obj) => ({
                                                  ...obj,
                                                  date: "",
                                                }));
                                              } else {
                                                setModalObj((obj) => ({
                                                  ...obj,
                                                  date: event?.$d,
                                                }));
                                                
                                              }
                                       
                                        }}
                                        // xError={xErrorMsg.A_PostDt === "" ? false : true}
                                        // xErrorMessage={xErrorMsg.A_PostDt}
                                        // xOnKeyUp={(e) => {
                                        //   xFocusInput("A_RefDocNo");
                                        // }}
                                      />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container className='button'>
                        <Grid item pt={4} xs={12}>
                            <Grid container sx={{display:'flex',justifyContent:'center'}}>
                                <Button variant='contained' size="large" color='inherit' onClick={fUpdate}>Update</Button>
                            </Grid>
                        </Grid>
                    </Grid>

                  </Box>  
                  </div>

        </div>
      </Box>
    </Modal>
  </>)}
  export default GcReferenceUpdate;